<th *ngFor="let i of [].constructor(pre)"></th>
<th *ngFor="let cd of columnDefs" (click)="setSortBy(cd.field)" [class]="'text-center cp-pre-text cp-pointer ' + extraClasses"
	[ngClass]="{ 'cp-sort-column-header': displayOptions.sortBy === cd.field, 'cp-icon-header': !!cd.icon }"
	[hidden]="!fieldsToShow.includes(cd.field)">
	<span *ngIf="cd.label" [innerHTML]="cd.label"
		[ngClass]="{'fst-italic': displayOptions.sortBy === cd.field && displayOptions.sortDir === 'desc'}"
		[ngbTooltip]="cd.toolTip ? cd.toolTip : cd.label"></span>
	<fa-icon *ngIf="cd.icon" [icon]="cd.icon" [ngbTooltip]="cd.toolTip ? cd.toolTip : cd.label"></fa-icon>
</th>
<th *ngFor="let i of [].constructor(post)"></th>